import { render, staticRenderFns } from "./ClaimManagement.vue?vue&type=template&id=7561f132&scoped=true&"
import script from "./ClaimManagement.vue?vue&type=script&lang=ts&"
export * from "./ClaimManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimManagement.vue?vue&type=style&index=0&id=7561f132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7561f132",
  null
  
)

export default component.exports